let EXP_OBJECT = {
   "applicantId": "",
   "isReviewSigned": 0
};

export {EXP_OBJECT};